function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawOnboarding = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1143.11 875.78",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 539.33,
    y1: 763.29,
    x2: 539.33,
    y2: 57.83,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 1034.54,
    y1: 812.84,
    x2: 1034.54,
    y2: 197.81,
    gradientTransform: "matrix(-1 0 0 1 1347.17 0)",
    xlinkHref: "#prefix__a"
  })), React.createElement("ellipse", {
    cx: 849.67,
    cy: 829.19,
    rx: 115.8,
    ry: 28.95,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M35.25 604.66c-13.1 4.49-29 13.65-26.32 28.21 1.34 7.38 7.32 12.85 13 17.47a368.3 368.3 0 0 0 79.36 49.15c13.57 6.16 28 11.81 38.25 23.17s15 27.24 18.33 42.55a345.86 345.86 0 0 1 5.72 110.41c40.91.78 86.21-.14 115.16-29.61 17.33-17.65 26.62-43.83 47-57.49 13.59-9.11 30.34-11.37 46.52-13.27q114.87-13.43 230.93-16.26c32.42-.79 65.55-1.07 95.82-12.37s57.75-36 63.9-69.49c.95-5.16 1.57-10.85 5.1-14.45 3.15-3.23 7.87-4 12.28-4.57l265.89-36c14.56-2 29.63-4.13 41.89-12.36 11.86-8 19.86-20.78 27.51-33.24 17.53-28.52 35.72-63 23.58-95.61-9.71-26.06-35.81-41.07-60.75-50.39s-51.79-15.87-72.06-34.14c-30.84-27.8-37.68-73.95-46.37-115.36a675.43 675.43 0 0 0-33-109.89c-12.44-31.34-27.59-62.23-50.17-86.62s-53.65-41.68-85.27-40.44c-41.3 1.64-77.63 33.83-119 29.83-34.94-3.35-63.37-31.35-94.83-48.77C521.87-5.83 455.95-3.11 394.84 6.54c-64.8 10.21-130 28.08-182.5 68.27-12 9.2-23.48 19.82-30.53 33.66-10.8 21.23-9.87 47.1-15.28 70.69-21.8 95-138.68 134.63-162.71 228.94-8.54 33.48-2.22 69.79 13.45 100.73 16.85 33.31 50.7 47.51 68.05 76.1-11.6 10.59-34.71 14.46-50.07 19.73z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M870.15 836.89s-10.48-72.2 21-119.72a110.5 110.5 0 0 0 18.68-67.38 185.42 185.42 0 0 0-5.1-33.61",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M924.47 586.09c-1.21 8.49-20.11 30.91-20.11 30.91s-11.81-26.83-10.63-35.32a15.53 15.53 0 1 1 30.74 4.41zM943.15 636.76c-5.64 6.46-33.69 15-33.69 15s4.64-29 10.27-35.42a15.533 15.533 0 1 1 23.42 20.41zM930.55 716.96c-8.13 2.74-36.66-4-36.66-4s18.62-22.66 26.75-25.39a15.53 15.53 0 0 1 9.91 29.39zM907.31 775.5c-7.55 4.07-36.81 2.2-36.81 2.2s14.52-25.47 22.07-29.54a15.53 15.53 0 0 1 14.74 27.34zM876.95 648.79c5.24 6.79 32.74 17 32.74 17s-2.92-29.18-8.16-36a15.534 15.534 0 0 0-24.58 19zM850.67 717.59c7 4.91 36.31 6.41 36.31 6.41s-11.5-27-18.54-31.88a15.53 15.53 0 1 0-17.77 25.47zM834.3 787.97c6.1 6 34.71 12.45 34.71 12.45s-6.78-28.53-12.89-34.53a15.53 15.53 0 1 0-21.82 22.1z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M924.47 586.09c-1.21 8.49-20.11 30.91-20.11 30.91s-11.81-26.83-10.63-35.32a15.53 15.53 0 1 1 30.74 4.41zM943.15 636.76c-5.64 6.46-33.69 15-33.69 15s4.64-29 10.27-35.42a15.533 15.533 0 1 1 23.42 20.41zM930.55 716.96c-8.13 2.74-36.66-4-36.66-4s18.62-22.66 26.75-25.39a15.53 15.53 0 0 1 9.91 29.39zM907.31 775.5c-7.55 4.07-36.81 2.2-36.81 2.2s14.52-25.47 22.07-29.54a15.53 15.53 0 0 1 14.74 27.34zM876.95 648.79c5.24 6.79 32.74 17 32.74 17s-2.92-29.18-8.16-36a15.534 15.534 0 0 0-24.58 19zM850.67 717.59c7 4.91 36.31 6.41 36.31 6.41s-11.5-27-18.54-31.88a15.53 15.53 0 1 0-17.77 25.47zM834.3 787.97c6.1 6 34.71 12.45 34.71 12.45s-6.78-28.53-12.89-34.53a15.53 15.53 0 1 0-21.82 22.1z",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M871.01 834.6s-38.84-61.76-29.27-118a110.5 110.5 0 0 0-10.19-69.15 185.49 185.49 0 0 0-18.29-28.66",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M819.06 583.32c2.32 8.26-5.87 36.41-5.87 36.41s-21.7-19.72-24-28a15.534 15.534 0 1 1 29.9-8.44zM856.66 622.08c-2.53 8.19-24.71 27.37-24.71 27.37s-7.5-28.34-5-36.54a15.532 15.532 0 0 1 29.68 9.17zM877.62 700.52c-6.32 5.79-35.15 11.15-35.15 11.15s7.84-28.25 14.16-34a15.536 15.536 0 0 1 21 22.9zM880.12 763.44c-5.25 6.78-32.76 16.93-32.76 16.93s3-29.17 8.2-36a15.53 15.53 0 1 1 24.56 19zM801.02 659.89c7.54 4.09 36.8 2.26 36.8 2.26s-14.48-25.49-22-29.57a15.531 15.531 0 1 0-14.8 27.31zM804.87 733.45c8.42 1.64 35.8-8.85 35.8-8.85s-21.45-20-29.87-21.63a15.53 15.53 0 1 0-5.93 30.48zM818.42 804.43c8 3 36.78-2.69 36.78-2.69s-17.76-23.32-25.78-26.36a15.53 15.53 0 0 0-11 29z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M285.63 57.83v705.46h507.4V57.83h-507.4z"
  }), React.createElement("path", {
    fill: "#f6f7f9",
    d: "M290.08 64.02h498.5v26.89h-498.5z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M290.08 64.02h498.5v26.89h-498.5z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#f6f7f9",
    d: "M290.08 90.91h498.5V757.1h-498.5z"
  }), React.createElement("circle", {
    cx: 303.19,
    cy: 77.47,
    r: 4.56,
    fill: "#f6f7f9"
  }), React.createElement("circle", {
    cx: 315.55,
    cy: 77.47,
    r: 4.56,
    fill: "#f6f7f9"
  }), React.createElement("circle", {
    cx: 327.91,
    cy: 77.47,
    r: 4.56,
    fill: "#f6f7f9"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M379.05 131.98H699.6v12.55H379.05z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M657.01 131.98h42.59v12.55h-42.59z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M337.61 203.47h403.44v144.49H337.61z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#f6f7f9",
    d: "M450.83 256.13h232.71v12.55H450.83zM450.83 282.75h120.73v12.55H450.83z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M657.01 320.77h42.59v12.55h-42.59z"
  }), React.createElement("circle", {
    cx: 386.28,
    cy: 275.71,
    r: 22.81,
    fill: "#f6f7f9"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M337.61 388.46h403.44v144.49H337.61z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#f6f7f9",
    d: "M450.83 441.12h232.71v12.55H450.83zM450.83 467.74h120.73v12.55H450.83z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M657.01 505.76h42.59v12.55h-42.59z"
  }), React.createElement("circle", {
    cx: 386.28,
    cy: 460.7,
    r: 22.81,
    fill: "#f6f7f9"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M337.61 573.45h403.44v144.49H337.61z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#f6f7f9",
    d: "M450.83 626.11h232.71v12.55H450.83zM450.83 652.73h120.73v12.55H450.83z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M657.01 690.75h42.59v12.55h-42.59z"
  }), React.createElement("circle", {
    cx: 386.28,
    cy: 645.69,
    r: 22.81,
    fill: "#f6f7f9"
  }), React.createElement("path", {
    d: "M192 466.51c-3.87 17.61-10.85 39.31-10.85 39.31 6.9 8.05 37 9.49 37 9.49l.05-.06h.47c.21 1.11.45 2.18.74 3.2q-.08 1.51-.15 3.06a8.35 8.35 0 0 0-.43 3.76 8.52 8.52 0 0 0 .22.84c-.72 15.94-1.23 32.94-.79 42.76a41.15 41.15 0 0 0 .85 8.28 29.81 29.81 0 0 1 .88 6.35c.49 14.37-3 38.51-3 38.51s.09.33.14.5c-.06.41-.1.65-.1.65a11.39 11.39 0 0 1 .51 3c.26 12.12-6.69 38.49-6.69 38.49s-5.62 40.55-4.82 56a35.62 35.62 0 0 0 .27 3.69c1.72 12.85 4 48.73 4 48.73a16.12 16.12 0 0 0 1.31 1.69c-.2.8-.44 1.61-.7 2.41a67.6 67.6 0 0 0-3.35 25.12c.07 1 .15 2.09.25 3.19 1.15 13.24 33.18 5 35.29 3.46.72-.53.21-5.33-.78-11.42l33 8.15s23.4 3.46 34.53 0 10.74-13-5.18-14.57c-11.15-1.08-20-11.46-24.37-17.59 1.69-4.61 14.36-39.6 16.69-61.26a306.66 306.66 0 0 1 7.39-41.52l2.49-32.23 4.42-19 5.27-25.12c5.95-18.42 7.77-49.21 7.77-49.21l4.6-30.21A58.48 58.48 0 0 0 330 505a111.68 111.68 0 0 1 12.75 3.41c7.2-5.6-3-59.56-3-59.56s-4.91-34.08-9.07-65.15c9.53-1.43 19.86.81 19.86.81l60.43 1.33a30.71 30.71 0 0 0 3.24-5.28h2.59a5.55 5.55 0 0 0 .75-1.46l1.07.2a89.37 89.37 0 0 1 11.56 3.51s19.06 2.3 16.18-17.69c-2.14-14.9-19.1-9.49-27.58-5.79l-1.07.49c-.08-.56-.13-.88-.13-.88l-2.73.5a13.2 13.2 0 0 0-.57-1.22s-29.64-1.15-53.67-4.75c-17.09-2.56-30-12.33-36.07-17.75-4.21-21.37-16.44-27.86-16.44-27.86-6.79-.34-12.91-3.33-16.67-5.64a35.23 35.23 0 0 1-3.9-2.7l-.66.38-.08-.07c4.07-3.78 8.29-7.25 12-10.16l1.67-1.29a37.07 37.07 0 0 0 30.28-51.91c-.16-.36-.35-.72-.52-1.07a8.32 8.32 0 0 0 7.34-7.23c.37-4.19-2.52-8.65-.63-12.41a12.06 12.06 0 0 0 .9-1.75 4.73 4.73 0 0 0 .14-1.76 12.39 12.39 0 0 0-5-9c-4.29-3.11-8.1-1.53-12.79-1.8-5.42-.31-10.79-1.62-16.13-2.5-6.13-1-12.41-1.68-18.53-.61s-12.11 4.07-15.66 9.17c-1.52 2.18-2.55 4.67-4 6.92-1.63 2.6-3.74 4.85-5.61 7.27-3.15 4.07-5.7 8.95-5.45 14.09.14 2.91 1.17 5.71 1.37 8.62a52.49 52.49 0 0 1-.6 8.1 35.46 35.46 0 0 0 .59 10.33 6.4 6.4 0 0 0 1.18 2.94 6.27 6.27 0 0 0 2.6 1.67 23.23 23.23 0 0 0 3.19 1 45.69 45.69 0 0 1-4.47 8.05l-1.62-1.68-4.38 6.84-.17-.46c-.21.43-.45.84-.7 1.25l-.45-1.25c-1.94 3.89-5.57 7.14-9.81 9.82-11.46 7.2-27.45 10.18-27.45 10.18-25.76 3.74-21 30.35-21 30.35s-10.93 47.48-14 76.83 8.34 48.05 8.34 48.05zm122.85-86.78c1 3.27 1.88 6.37 2.63 9.08l-.48.19c-.55-2.51-1.3-5.73-2.12-9.27zm-28.34-79.67l-.14.09.13-.13zm-44.43 496.13c-1.26-7.53-3.14-16.62-4.3-22.05.82-2.67 1.91-6.75 3.19-12.82 2.88-13.61 4.6-61.77 4.6-61.77l6.72-40.46c6.14-15.54 7.48-34 7.48-34 2.47-6.52 8.18-46.43 9.09-52.84-.26 4.43-.88 15.65-1.21 28.11v.34c-.25 9.41-.32 19.5 0 27.87.09 2.35.21 4.58.37 6.64.05.53.08 1.08.1 1.62.72 21.7-9 49-9 49s-4.33 20.24-3.69 31.55a20.82 20.82 0 0 0 .86 6 10.61 10.61 0 0 1 .49 2.78c.18 10.82-6.21 33.53-7.84 39.1-3.56 7.34-6.21 26.05-6.86 30.93z",
    transform: "translate(-28.45 -12.11)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M249.28 754.55s11.22 20.34 27 21.86 16.16 11 5.13 14.45-34.22 0-34.22 0l-33.08-8.17s4-32.7 9.31-34.41 25.86 6.27 25.86 6.27z",
    fill: "#4c4c78"
  }), React.createElement("path", {
    d: "M208.97 754.89s8.37 37.64 6.28 39.17-33.84 9.69-35-3.43c-.1-1.09-.18-2.15-.24-3.16a66.64 66.64 0 0 1 3.32-24.9 20.63 20.63 0 0 0 1.29-7.68c-.55-5.28 24.35 0 24.35 0z",
    fill: "#4c4c78"
  }), React.createElement("path", {
    d: "M219.34 278.36s25.66 63 21.1 42.8c-3-13.42 16.51-31.23 30-41.7 6.87-5.34 12.19-8.77 12.19-8.77s-48.2-56.18-44.78-31.94a36.5 36.5 0 0 1-2.63 19.56 51.28 51.28 0 0 1-15.88 20.05zM383.32 367.89a14.75 14.75 0 0 1 5.87.37 86.62 86.62 0 0 1 11.45 3.48s18.9 2.28 16-17.53c-2.12-14.78-18.92-9.42-27.33-5.74-2.86 1.25-4.76 2.31-4.76 2.31z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M383.32 367.89a14.75 14.75 0 0 1 5.87.37c2.05-5.19.49-17.48.16-19.79-2.86 1.25-4.76 2.31-4.76 2.31z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M383.22 349.02l4.94-.91s2.54 17-.77 21.44h-5.69z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M284.07 380.01s15.12-9 16.92 2.37 4.19 30.9 4.19 30.9l4.18 24.81 5.42 49.72-.76 8.46s-16.07-5.38-19.87-3.52-6.85-20.86-6.85-20.86l-6.27-23.58-1-50z",
    fill: "#4c4c78"
  }), React.createElement("path", {
    d: "M284.07 380.01s15.12-9 16.92 2.37 4.19 30.9 4.19 30.9l4.18 24.81 5.42 49.72-.76 8.46s-16.07-5.38-19.87-3.52-6.85-20.86-6.85-20.86l-6.27-23.58-1-50z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M292.2 321.45s15.69 17.68 39.5 21.25 53.19 4.7 53.19 4.7 7.41 13.26-3.28 27.38l-59.89-1.32s-13.26-2.88-23.53 0z",
    fill: "#4c4c78"
  }), React.createElement("path", {
    d: "M292.2 321.45s15.69 17.68 39.5 21.25 53.19 4.7 53.19 4.7 7.41 13.26-3.28 27.38l-59.89-1.32s-13.26-2.88-23.53 0z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M237.78 257.76c5.85 12.51 16 21.74 30.76 21.74h1.92c6.87-5.34 12.19-8.77 12.19-8.77s-48.2-56.18-44.78-31.94c1.05 7.37 2.26 13.4-.09 18.97z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M231.8 241.62a36.74 36.74 0 1 0 36.75-36.73 36.66 36.66 0 0 0-36.75 36.73z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M209.35 466.13s81.94 7.23 85-3.23-8.36-38.78-8.36-38.78l3.66-39.55.14-1.52s-10.24-42.78-9.9-46.16c.35-3.07-16.53-39-20-46.31l-.63-1.32-.65.38-.28.17-4 2.34-15.87-3.74-19.1-10-1.81 109.4z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M251.94 290.55s5.61-1.52 7.8 4.09a57.66 57.66 0 0 0 3 7l2.19 13 4 20.53 2.94 91-1.32 16.2-7.32-13-1.33-85v-10.6a76.71 76.71 0 0 0-6.1-26.56l-1-2.39-6.37-8.17z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M253.08 289.41s5.61-1.52 7.8 4.09a57.66 57.66 0 0 0 3 7l2.19 13 4 20.53 2.95 91-1.34 16.16-7.32-13-1.33-85v-10.6a76.7 76.7 0 0 0-6.09-26.56l-1-2.39-6.39-8.14z",
    fill: "#4c4c78"
  }), React.createElement("path", {
    d: "M229.13 265.89s19.39 20.54 26.23 23c0 0-3.42 15.59-6.84 18.63 0 0-20.35-20.75-24-22.43l-3-7.39z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M229.13 264.79s19.39 20.54 26.23 23c0 0-3.42 15.59-6.84 18.63 0 0-20.35-20.75-24-22.43l-3-7.39z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M258.13 289.24l.2.53 6.22 16.66 11.1 31.46s.11.32.3.92c1.84 5.72 11.74 36.77 13.69 45.8l.14-1.52s-10.23-42.82-9.89-46.2c.35-3.07-16.53-39-20-46.31-.55-.38-1-.7-1.28-.94z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M259.26 289.22l6.42 17.21 11.11 31.46s.11.32.3.92c1.95 6.1 13.06 40.9 14 47.27 1 7 15 44.78 15 44.78l8 65.45c7.13-5.56-3-59-3-59s-11.41-79.28-14.11-105.65-17.33-34.17-17.33-34.17c-6.73-.34-12.79-3.3-16.52-5.59a35.28 35.28 0 0 1-3.87-2.68z",
    fill: "#4c4c78"
  }), React.createElement("path", {
    d: "M178.75 710.25c1.71 12.74 4 48.3 4 48.3 8 12 25.67 5.51 25.67 5.51s1.89-3.62 4.74-17.12 4.57-61.22 4.57-61.22l6.66-40.11c6.08-15.4 7.41-33.65 7.41-33.65 2.66-7 9.13-53.24 9.13-53.24s-2.67 41.45-1 63.31-8.74 51.34-8.74 51.34-5.9 27.57-2.85 36.12-7.61 43.92-7.61 43.92c.95 10.27 31.18 6.08 31.18 6.08s14.26-38.21 16.73-61.22a303.86 303.86 0 0 1 7.33-41.16l2.46-31.94 4.38-18.82 5.23-24.9c5.89-18.26 7.7-48.77 7.7-48.77l4.56-29.94c3-14.81-.87-32.17-3.47-41.29-1.12-3.93-2-6.34-2-6.34-2.62 1.86-17.62 4-25.38 5.81a44.16 44.16 0 0 1-13 1 288.83 288.83 0 0 1-57.9-10.59l-2-.6-.4 3.42-.94 8.16-1.66 14.47s-5.14 77.19-2.1 87.65-2.09 45.59-2.09 45.59c2.85 8.34-6.08 42.24-6.08 42.24s-6.24 45.26-4.53 57.99z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M178.75 709.11c1.71 12.74 4 48.3 4 48.3 8 12 25.67 5.51 25.67 5.51s1.89-3.62 4.74-17.12 4.57-61.22 4.57-61.22l6.66-40.11c6.08-15.4 7.41-33.65 7.41-33.65 2.66-7 9.13-53.24 9.13-53.24s-2.67 41.45-1 63.31-8.74 51.34-8.74 51.34-5.9 27.57-2.85 36.12-7.61 43.92-7.61 43.92c.95 10.27 31.18 6.08 31.18 6.08s14.26-38.21 16.73-61.22a303.86 303.86 0 0 1 7.33-41.16l2.46-31.94 4.38-18.82 5.23-24.9c5.89-18.26 7.7-48.77 7.7-48.77l4.56-29.95c3-14.8-.87-32.16-3.47-41.28-1.12-3.93-2-6.34-2-6.34-2.62 1.86-17.62 4-25.38 5.81a44.16 44.16 0 0 1-13 1 288.83 288.83 0 0 1-57.9-10.59l-2-.6-.4 3.42-.94 8.16-1.66 14.47s-5.14 77.19-2.1 87.65-2.06 45.6-2.06 45.6c2.85 8.34-6.08 42.24-6.08 42.24s-6.27 45.25-4.56 57.98z",
    fill: "#474463"
  }), React.createElement("path", {
    d: "M231.8 241.62a36.66 36.66 0 0 0 4.87 18.27c5.72 1 11.81-.1 16.14-3.89 2.93-2.58 4.82-6.11 7.34-9.1a53.49 53.49 0 0 1 5.25-5.18 16.26 16.26 0 0 1 4.14-3 5.62 5.62 0 0 1 5-.06c2 1.13 2.72 3.64 3.86 5.65a7.54 7.54 0 0 0 4.21 3.67 4.46 4.46 0 0 0 5-1.71c1.24-2.14.33-5.48 2.42-6.78a12.6 12.6 0 0 1 1.7-.69c2.69-1.22 3-4.83 3.22-7.77.12-1.45.43-3.09 1.65-3.87s2.81-.39 4.26-.35a6 6 0 0 0 1.28-.11 36.74 36.74 0 0 0-70.33 14.89z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M304.34 193.89a12.2 12.2 0 0 1 4.95 8.88 4.67 4.67 0 0 1-.13 1.75 13 13 0 0 1-.89 1.74c-1.88 3.72 1 8.14.62 12.3a8.18 8.18 0 0 1-8 7.18c-1.45 0-3-.43-4.26.35s-1.53 2.42-1.65 3.87c-.23 2.95-.53 6.56-3.22 7.77a14.11 14.11 0 0 0-1.7.7c-2.09 1.3-1.17 4.65-2.42 6.77a4.45 4.45 0 0 1-5 1.72 7.58 7.58 0 0 1-4.21-3.67c-1.15-2-1.84-4.52-3.86-5.65a5.65 5.65 0 0 0-5 .05 16.3 16.3 0 0 0-4.14 3 54.63 54.63 0 0 0-5.25 5.18c-2.52 3-4.41 6.52-7.35 9.1-5.52 4.85-14 5.33-20.8 2.57a6.36 6.36 0 0 1-2.58-1.65 6.46 6.46 0 0 1-1.2-2.96 35.54 35.54 0 0 1-.59-10.24 51.68 51.68 0 0 0 .6-8c-.19-2.88-1.22-5.66-1.36-8.54-.25-5.09 2.28-9.93 5.4-14 1.86-2.4 3.95-4.63 5.56-7.2 1.4-2.23 2.42-4.7 3.93-6.86 3.52-5 9.46-8 15.52-9.09s12.29-.4 18.37.6c5.29.88 10.61 2.17 16 2.48 4.63.28 8.41-1.29 12.66 1.85z",
    fill: "#472727"
  }), React.createElement("path", {
    d: "M259.26 289.22l6.42 17.21 11.11 31.46s.11.32.3.92l-14-46.91a35.28 35.28 0 0 1-3.83-2.68z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M189.87 486.1s-.67 20.81 4.94 26l14.92-28.14-12.54-6.07z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M155.03 493.7c6.85 8 36.64 9.41 36.64 9.41l29.53-46.48s7-4.85 20.09-26.67 12.69-38.64 12-51.19-9-48.63-9-48.63c-1.27-8.12-19.66-59-19.66-59-1.93 3.86-5.52 7.07-9.73 9.73-11.35 7.11-27.22 10.02-27.22 10.02-25.53 3.71-20.82 30.09-20.82 30.09s-.31 102.57 1.29 114.83-13.12 57.89-13.12 57.89z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#cbcdda",
    d: "M189.49 490.09l.85 7.6 10.37-3.8 7.6-11.5-5.7-4.47-13.12 12.17z"
  }), React.createElement("path", {
    d: "M189.85 460.62l5.42.55 52.28 5.22a84.69 84.69 0 0 0 25.12-1.23l24.23-4.85c-1.12-3.93-2-6.34-2-6.34-2.62 1.86-17.62 4-25.38 5.81a44.16 44.16 0 0 1-13 1 288.83 288.83 0 0 1-57.97-10.59l-2.36 2.82z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M294.3 454.26a5.45 5.45 0 0 0 .51-.29l.05.14zM183.26 651.12s8.94-33.9 6.08-42.24c0 0 5.14-35.13 2.09-45.59s2.1-87.65 2.1-87.65l1.69-14.47 1-8.16.4-3.42s.68.22 2 .6l1.21.36-.28 1.34-.95 8.16-1.69 14.47s-5.13 77.18-2.1 87.65-2.08 45.59-2.08 45.59c2.85 8.34-6.08 42.24-6.08 42.24s-6.28 45.26-4.57 58 4 48.29 4 48.29c5.83 8.76 16.84 7.66 22.34 6.43-.06.15-.1.23-.1.23s-17.68 6.46-25.67-5.51c0 0-2.28-35.56-4-48.3s4.61-58.02 4.61-58.02zM228.32 708.35c-3-8.55 2.86-36.12 2.86-36.12s10.44-29.47 8.73-51.34c-.71-9.11-.66-21.61-.36-33.1 2.43-14.8 4.74-31.35 4.74-31.35s-2.67 41.44-.95 63.31-8.74 51.34-8.74 51.34-5.9 27.57-2.85 36.12-7.61 43.92-7.61 43.92c.76 8.23 20.3 7.18 28 6.43l-.29.79s-30.23 4.19-31.17-6.08c.04 0 10.68-35.38 7.64-43.92z"
  })), React.createElement("path", {
    d: "M153.89 493.7c6.85 8 36.64 9.41 36.64 9.41l29.52-46.48s7-4.85 20.1-26.67 12.69-38.64 12-51.19-9-48.63-9-48.63c-1.27-8.12-19.66-59-19.66-59-1.93 3.86-5.52 7.07-9.73 9.73-11.36 7.11-27.21 10.02-27.21 10.02-25.53 3.71-20.82 30.09-20.82 30.09s-.28 102.53 1.29 114.79-13.13 57.93-13.13 57.93z",
    fill: "#4c4c78"
  }), React.createElement("path", {
    d: "M218.05 296.35l6.42 2.42-4.28 3 31.92 77c-.74-12.55-9-48.63-9-48.63-1.27-8.12-19.66-59-19.66-59-1.93 3.86-5.52 7.07-9.73 9.73zM210.36 433.52l-32.66-8.41-4.28 13.26 33.37 8.13 3.57-12.98z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M191.67 301.77s14.83 14 9.27 45.06-14.54 64.88-14.54 64.88l24.15 66.88s-16.83 17.54-25.1 19.67l-24.1-53.47s-11.26-18.54-8.27-47.62 13.83-76.15 13.83-76.15-.05-28.66 24.76-19.25z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M190.55 301.77s14.83 14 9.27 45.06-14.54 64.88-14.54 64.88l24.07 66.88s-16.8 17.54-25.09 19.67l-24.1-53.47s-11.26-18.54-8.27-47.62 13.83-76.15 13.83-76.15 0-28.66 24.83-19.25z",
    fill: "#4c4c78"
  }), React.createElement("path", {
    d: "M208.55 480.01s-18.82 26-17.39 33 6.94 3.23 6.94 3.23l7.45-10.18 6.66-19s-.66-8.17-3.66-7.05z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M210.88 480.01s-18.83 26-17.4 33 6.94 3.23 6.94 3.23l7.41-10.17 6.66-19s-.65-8.18-3.61-7.06z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M209.73 480.01s-18.82 26-17.39 33 6.94 3.23 6.94 3.23l7.41-10.17 6.66-19s-.65-8.18-3.62-7.06z",
    fill: "#474463"
  }));
};

UndrawOnboarding.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawOnboarding;